<nav class="navbar-custom border-bottom border-dark shadow-sm main-nav" aria-label="navbar">
  <div class="top-bar border-bottom border-dark">
    <div class="container container-responsive pt-2 pb-2">
      <div class="row align-items-center g-0 py-2">
        <div class="col-auto d-flex align-items-center gap-3">

          <a href="https://business.skeinforce.com/" target="_blank" rel="noopener noreferrer"
            class="btn btn-sm rounded-pill syne-text discover-btn fs-18 py-1 px-3">
            {{ 'discover_skeinforce' | translate }}
          </a>

          <!-- <a href="https://business.skeinforce.com/" target="_blank" rel="noopener noreferrer"
            class="fs-20 syne-text text-black text-decoration-none d-none d-md-block">
            BUSINESS
          </a>
          <div class="dropdown">
            <div class="fs-20 lang-btn dropdown-toggle bg-transparent text-black" data-bs-toggle="dropdown"
              aria-expanded="false">
              {{ selectedLang | uppercase }}
            </div>
            <ul class="dropdown-menu custom-dropdown dropdown-menu-center">
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('it')">Italiano</a></li>
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('en')">English</a></li>
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('es')">Español</a></li>
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('de')">Deutsche</a></li>
            </ul>
          </div> -->
        </div>

        <div class="col text-center">
          <a class="logo-brand">
            <img routerLink="/home" class="logo-home" src="../assets/images/logos/logo_skeinforce.png" alt="Skeinforce">
          </a>
        </div>

        <div class="col-auto ms-auto" *ngIf="isUserLoaded">
          <ng-container *ngIf="currentUser; else loginBtn">
            <div class="dropdown">
              <div class="custom-btn d-flex align-items-center px-3" data-bs-toggle="dropdown" aria-expanded="false">
                <span
                  class="rounded-circle d-flex align-items-center username-btn justify-content-center fs-20 syne-text btn-gradient">
                  {{ getUserName(currentUser) | uppercase }}
                </span>
                <span class="fs-20 syne-text text-black d-none small d-md-inline dropdown-toggle ms-1">
                  {{ [1, 4, 6].includes(currentUser?.RoleId)? formatName(currentUser?.CompanyName):
                  formatName(currentUser?.FirstName)}}</span>
              </div>

              <ul class="dropdown-menu custom-dropdown dropdown-menu-center mt-2">
                <!-- <li>
                  <a class="dropdown-item bg-transparent text-black" routerLink="/profile/edit-page">
                    {{ 'profile' | translate }}
                  </a>
                </li> -->
                <li *ngIf="currentUser?.RoleId === 1 || currentUser?.RoleId === 6">
                  <a class="dropdown-item bg-transparent text-black" routerLink="/profile/edit-content">
                    {{ 'dashboard' | translate}}
                  </a>
                </li>

                <li *ngIf="currentUser?.RoleId !== 1 && currentUser?.RoleId !== 6">
                  <a class="dropdown-item bg-transparent text-black" routerLink="/profile/edit-page">
                    {{ 'dashboard' | translate}}
                  </a>
                </li>
                <li>
                  <a class="dropdown-item bg-transparent text-black" routerLink="/profile/setting">
                    {{ 'setting' | translate }}
                  </a>
                </li>
                <li>
                  <a class="dropdown-item bg-transparent text-black" (click)="logout()">
                    {{ 'disconnect' | translate }}</a>
                </li>
              </ul>
            </div>
          </ng-container>

          <ng-template #loginBtn>
            <button class="btn btn-gradient rounded-pill px-4 py-2 small" (click)="goToLogin()">
              {{ 'home2' | translate }}
            </button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div class="menu-bar">
    <div class="container container-responsive nav-container">

      <div class="d-flex align-items-center">

        <!-- Mobile Toggle -->
        <button class="navbar-toggler d-lg-none me-2" type="button" data-bs-toggle="collapse" data-bs-target="#menuNav"
          aria-controls="menuNav" aria-expanded="false">
          <span class="navbar-toggler-icon"></span>
        </button>

        <!-- Collapsible Menu -->
        <div class="collapse d-lg-flex flex-grow-1" id="menuNav">
          <nav class="d-flex flex-column flex-lg-row align-items-start align-items-lg-center gap-3 gap-lg-4 syne-text"
            aria-label="Main navigation">
            <a class="nav-link fs-20" routerLink="/home" routerLinkActive="active">
              {{ 'home4' | translate }}
            </a>
            <a class="nav-link fs-20" routerLink="/bimcloud" routerLinkActive="active">
              {{ 'bim' | translate }}
            </a>
            <a class="nav-link fs-20" routerLink="/texture" routerLinkActive="active">
              {{ 'texture' | translate }}
            </a>
            <a class="nav-link fs-20" routerLink="/collections" routerLinkActive="active">
              {{ 'collection' | translate }}
            </a>
            <a class="nav-link fs-20" routerLink="/news-projects" routerLinkActive="active">
              {{ 'articles_and_projects' | translate }}
            </a>
            <a class="nav-link fs-20" routerLink="/ourskein" routerLinkActive="active">
              {{ 'company1' | translate }}
            </a>
            <!-- <a class="nav-link fs-20" routerLink="/studios" routerLinkActive="active">
              {{ 'studios' | translate }}
            </a> -->
            <a class="nav-link fs-20" routerLink="/contacts" routerLinkActive="active">
              {{ 'contacts' | translate }}
            </a>
          </nav>
        </div>

        <!-- Right Icons (Always Visible) -->
        <div class="ms-auto d-flex gap-4 align-items-center pe-2">
          <!-- <i class="icon skf-notification cursor-pointer"></i> -->
          <div class="dropdown">
            <div class="fs-20 lang-btn dropdown-toggle bg-transparent text-black" data-bs-toggle="dropdown"
              aria-expanded="false">
              <!-- {{ selectedLang | uppercase }} -->
              {{ this.translate.getCurrentLang() | uppercase }}
            </div>
            <ul class="dropdown-menu custom-dropdown dropdown-menu-center">
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('it')">Italiano</a></li>
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('en')">English</a></li>
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('es')">Español</a></li>
              <li><a class="dropdown-item bg-transparent text-black" (click)="changeLang('de')">Deutsche</a></li>
            </ul>
          </div>
          <i class="icon skf-search cursor-pointer" (click)="onSearch()" onkeyup=""></i>
        </div>

      </div>
    </div>
  </div>
</nav>